import { useAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { useIsPast } from '@b-stock/fe-core/bstock-react'

import { useIsUserEligibleToBid } from '@/buyer-portal/components/features/listing/actions/auction/useIsUserEligibleToBid'
import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import { AuctionActionCell } from '../AuctionActionCell'
import { ViewDetailsButton } from './ViewDetailsButton'

/**
 * The action column's form: every route a row can take to a single control.
 *
 * "View Details" is one of these states rather than an action in the menu — it
 * occupies the same slot as the bid input and CTA. All of the routes to it live
 * here.
 */
export const ActionForm = ({
  isSentinel,
  searchListing,
}: {
  /**
   * The column's `valueGetter` withholds the bid amount for Make-an-Offer
   * listings, and for listings whose terms the buyer has not accepted, marking
   * the cell with SENTINEL. Those rows route to View Details like the rest.
   */
  isSentinel: boolean
  searchListing: CombinedListingSearchResult
}) => {
  const { endTime, is3MP, listingType, pricingStrategy, sellerId } =
    searchListing
  const isLoggedIn = !!useAccessToken()
  const eligibleToBid = useIsUserEligibleToBid({ sellerId })
  const isEnded = useIsPast(endTime)

  const viewDetails = <ViewDetailsButton listing={searchListing} />

  if (isSentinel) {
    return viewDetails
  }

  if (isEnded) {
    return viewDetails
  }

  if (isLoggedIn && !eligibleToBid) {
    return viewDetails
  }

  if (listingType === 'CONTRACT') {
    return viewDetails
  }

  if (is3MP && pricingStrategy === 'AUCTION') {
    return <AuctionActionCell searchListing={searchListing} />
  }

  return viewDetails
}
